import React from 'react';
import { EffectFade, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from "swiper/react";
import PageHeder from '../../components/PageHeder';
import Paragraph from '../../components/Paragraph';
import ProjectCard09 from '../../components/ProjectElements/ProjectCard09';
import SectionGridLines from '../../components/SectionGridLines';
import SectionHeader from '../../components/SectionHeader';

const ProjectGallery09 = () => {
    const ProjectData01 = [
        {
            id: '1',
            img: 'images/portfolio/packery/10.png',
            details: 'Twilight on the Water',
            title: 'Bayside Luxury',
            tag: 'landscape'
        },
        {
            id: '2',
            img: 'images/portfolio/packery/9.png',
            details: 'Your private courtyard in an enclosed garden',
            title: 'Private Luxury',
            tag: 'landscape'
        },
        {
            id: '3',
            img: 'images/portfolio/packery/12.png',
            details: 'Exclusive moments with friends and family',
            title: 'Family Gatherings',
            tag: 'landscape'
        },
        {
            id: '4',
            img: 'images/portfolio/packery/15.png',
            details: 'Tropical oasis in your backyard',
            title: 'Tropical Paradise',
            tag: 'landscape'
        },
        {
            id: '5',
            img: 'images/portfolio/packery/14.png',
            details: 'Majestic beachfront views from your luxury landscape',
            title: 'Beachfront Luxury',
            tag: 'landscape'
        },
        {
            id: '6',
            img: 'images/portfolio/packery/13.png',
            details: 'Elegant and functional dock space for your boating needs',
            title: 'Dockside Elegance',
            tag: 'landscape'
        },
    ];


    return (
        <section className="projects packery">
            <SectionGridLines />
            <div className="large_font">
                <SectionHeader title="Gallery" />
            </div>
            <div className="container">
                <div className="section-header text-center has_line">
                    <PageHeder className='text-white' title="Project Gallery" />
                    <div className="section-desc row align-items-center justify-content-center">
                        <div className="col-lg-6 text-end">
                            <Paragraph text="We blend luxury and sustainability, cultivating sophisticated outdoor environments that inspire and endure. Our precision-driven process combines high-tech automation with human ingenuity, allowing us to deliver personalized designs that perfectly align with your vision and the unique characteristics of your property." />
                        </div>
                        <div className="col-lg-6 text-start">
                            <Paragraph text="Our steadfast commitment to excellence has positioned us as a trusted partner for luxury landscaping projects across Florida. When you choose FloridaLandscape.Luxury, you're not just getting a service – you're embracing a lifestyle of outdoor elegance." />
                        </div>
                    </div>
                </div>

                <div className="swiper swiper_gallery_2">
                    <Swiper
                        modules={[Navigation, EffectFade]}
                        effect="slide"
                        breakpoints={{
                            // 640: {
                            //     width: 640,
                            //     slidesPerView: 1,
                            // },
                            // 768: {
                            //     width: 768,
                            //     slidesPerView: 2,
                            // },
                            // 992: {
                            //     width: 920,
                            //     slidesPerView: 2,
                            // },

                            600: {
                                slidesPerView: 2,
                            },
                            992: {
                                slidesPerView: 3,
                            },
                        }}
                        spaceBetween={30}
                        loop={true}
                        navigation={{
                            prevEl: '.swiper-button-prev',
                            nextEl: '.swiper-button-next',
                        }}
                    >
                        {
                            ProjectData01.map(data => <SwiperSlide> <ProjectCard09
                                key={data.id}
                                data={data}
                            /></SwiperSlide>)
                        }
                    </Swiper>

                    {/* <!-- Add Buttons --> */}
                    <div className="swiper-button-prev details_link l-dir pagination-previous"><a href="#"><span className="link_icon"><span className="line"></span> <span className="circle"></span><span className="dot"></span></span></a></div>
                    <div className="swiper-button-next details_link r-dir pagination-next"><a href="#"><span className="link_icon"><span className="line"></span> <span className="circle"></span><span className="dot"></span></span></a></div>
                </div>

            </div>
        </section>
    );
};

export default ProjectGallery09;
